export default __webpack_public_path__ + "static/media/124_chronoklok.1ad553ae.webp";